// To generate menubar only for demo/FED catalog
const structure = {
    lis: [
        {
            title: 'Search Truck Inventory',
            lis: [
                {
                    title: 'search all trucks'
                },
                {
                    title: 'by type',
                    lis: [
                        {
                            title: 'new'
                        },
                        {
                            title: 'used'
                        },
                        {
                            title: 'certified'
                        },
                    ]
                },
                {
                    title: 'by class',
                    lis: [
                        {
                            title: 'heavy'
                        },
                        {
                            title: 'medium'
                        },
                        {
                            title: 'light'
                        },
                    ]
                },
                {
                    title: 'by category',
                    lis: [
                        {
                            title: 'tractor'
                        },
                        {
                            title: 'cab'
                        },
                        {
                            title: 'vocational',
                            lis: [
                                {
                                    title: 'Tow'
                                },
                                {
                                    title: 'refuse'
                                },
                                {
                                    title: 'crane'
                                },
                                {
                                    title: 'mixer'
                                },
                            ]
                        },
                        {
                            title: 'trailers'
                        },
                        {
                            title: 'work'
                        },
                        {
                            title: 'Electric'
                        },
                        {
                            title: 'buses',
                            lis: [
                                {
                                    title: 'comercial'
                                },
                                {
                                    title: 'school'
                                },
                            ]
                        },
                    ]
                },
                {
                    title: 'by brand',
                    lis: [
                        {
                            title: 'Tow'
                        },
                        {
                            title: 'peterbilt'
                        },
                        {
                            title: 'international'
                        },
                        {
                            title: 'ford'
                        },
                        {
                            title: 'hino'
                        },
                        {
                            title: 'izusu'
                        },
                        {
                            title: 'ic'
                        },
                        {
                            title: 'collins'
                        },
                        {
                            title: 'blue'
                        },
                        {
                            title: 'microbird'
                        },
                    ]
                },
            ]
        },
        {
            title: 'Truck Sales',
            lis: [
                {
                    title: 'find'
                },
                {
                    title: 'sales',
                    lis: [
                        {
                            title: 'new'
                        },
                        {
                            title: 'used'
                        },
                        {
                            title: 'ready'
                        },
                    ]
                },
                {
                    title: 'leasing'
                },
                {
                    title: 'brands',
                    showMenuAsColumn: true,
                    lis: [
                        {
                            title: 'truck',
                            lis: [
                                {
                                    title: 'peterbilt',
                                    lis: [
                                        {
                                            title: 'overview',
                                        },
                                        {
                                            title: 'on',
                                        },
                                        {
                                            title: 'vocational',
                                        },
                                        {
                                            title: 'medium',
                                        },
                                        {
                                            title: 'electric',
                                        },
                                    ]        
                                },
                                {
                                    title: 'ford',
                                    lis: [
                                        {
                                            title: 'overview',
                                        },
                                        {
                                            title: 'light',
                                        },
                                        {
                                            title: 'medium',
                                        },
                                        {
                                            title: 'super',
                                        },
                                        {
                                            title: 'light dutty',
                                        },
                                        {
                                            title: 'medium dutty',
                                        },
                                        {
                                            title: 'super dutty',
                                        },
                                        {
                                            title: 'e-series',
                                        },
                                    ]        
                                },
                                {
                                    title: 'international',
                                    lis: [
                                        {
                                            title: 'overview',
                                        },
                                        {
                                            title: 'light',
                                        },
                                        {
                                            title: 'medium',
                                        },
                                        {
                                            title: 'super',
                                        },
                                        {
                                            title: 'light dutty',
                                        },
                                        {
                                            title: 'medium dutty',
                                        },
                                    ]
                                },
                                {
                                    title: 'hino',
                                    lis: [
                                        {
                                            title: 'overview',
                                        },
                                        {
                                            title: 'light',
                                        },
                                        {
                                            title: 'medium',
                                        },
                                    ]
                                },
                                {
                                    title: 'isuzu',
                                    lis: [
                                        {
                                            title: 'overview',
                                        },
                                        {
                                            title: 'light',
                                        },
                                        {
                                            title: 'medium',
                                        },
                                    ]
                                },
                            ]
                        },
                        {
                            title: 'bus',
                            lis: [
                                {
                                    title: 'ic',
                                    lis: [
                                        {
                                            title: 'overview',
                                        },
                                        {
                                            title: 'light',
                                        },
                                        {
                                            title: 'medium',
                                        },
                                    ]
                                },
                                {
                                    title: 'collins',
                                    lis: [
                                        {
                                            title: 'overview',
                                        },
                                        {
                                            title: 'light',
                                        },
                                        {
                                            title: 'medium',
                                        },
                                        {
                                            title: 'extra',
                                        },
                                    ]
                                },
                                {
                                    title: 'blue',
                                    lis: [
                                        {
                                            title: 'overview',
                                        },
                                        {
                                            title: 'light',
                                        },
                                        {
                                            title: 'medium',
                                        },
                                    ]
                                },
                                {
                                    title: 'micro',
                                    lis: [
                                        {
                                            title: 'overview',
                                        },
                                        {
                                            title: 'light',
                                        },
                                        {
                                            title: 'medium',
                                        },
                                    ]
                                },
                            ]
                        },
                    ]
        },
            ]
        },
        {
            title: 'Service',
        },
        {
            title: 'Parts',
            lis: [
                {
                    title: 'shop parts',
                    lis: [
                        {
                            title: 'used',
                        },
                        {
                            title: 'new',
                        },
                        {
                            title: 'ready',
                        },
                    ]
                },
                {
                    title: 'parts specials',
                },
                {
                    title: 'rig tough truck parts',
                },
            ]            
        },
        {
            title: 'Electric',
        },
        {
            title: 'About us',
        },
    ]
}

// To generate menubar only for demo/FED catalog
export class GenerateMenu {

    static isDesktop;

    static createA(txt, hasPopup = false, level) {
        const anchor = document.createElement('a');
        anchor.textContent = txt;
        anchor.setAttribute('role', 'menuitem');
        anchor.setAttribute('href', '#');
        if (hasPopup) {
            anchor.setAttribute('aria-haspopup', true);
            anchor.setAttribute('aria-expanded', false);
            if (level < 3 && this.isDesktop) {
                if (level === 1) {
                    const imgD = document.createElement('img');
                    imgD.setAttribute('src', 'images/chevron-down.svg');
                    imgD.setAttribute('alt', '');
                    imgD.classList.add('color--dark50', 'arrow-desktop');
                    anchor.append(imgD);
                }
                const imgM = document.createElement('img');
                imgM.setAttribute('src', 'images/breadcrumb-right.svg');
                imgM.setAttribute('alt', '');
                imgM.classList.add('color--dark50', 'arrow-mobile');
                anchor.append(imgM);
            } else if (level === 1 && !this.isDesktop) {
                const imgM = document.createElement('img');
                imgM.setAttribute('src', 'images/breadcrumb-right.svg');
                imgM.setAttribute('alt', '');
                imgM.classList.add('color--dark50', 'arrow-mobile');
                anchor.append(imgM);
            }
        }
        return anchor;
    }

    static createLi(obj, role = 'none', level = 1) {
        const li = document.createElement('li');

        li.setAttribute('role', role);
        // li.classList.add(`menu-option-level-${level}`);

        const hasSubMenu = obj.lis && obj.lis.length;
        const anchor = this.createA(obj.title, hasSubMenu, level);
        li.appendChild(anchor);
        if (hasSubMenu) {
            const newUL = this.createSubmenu(obj.title, obj.lis, level + 1, level === 1 ? 'group' : 'menu', obj.showMenuAsColumn);
            li.appendChild(newUL);
        }
        return li;
    }

    static createSubmenu (title, lis, level, role, showMenuAsColumn) {
        const ul = document.createElement('ul');
        ul.setAttribute('role', role);
        ul.setAttribute('data-level', level);
        ul.setAttribute('aria-label', title);

        if (showMenuAsColumn) {
            ul.classList.add('main-nav__ctas-menu-nav--columns');
        }
        ul.classList.add(`menubar-level-${level}`);

        lis.forEach(element => {
           const newLI = this.createLi(element, 'none', level);
           ul.appendChild(newLI);
        });
        return ul;
    }

    static generate(element, isDesktop) {
        this.isDesktop = isDesktop;

        const mainUL = element.querySelector(':scope .main-nav__ctas-menu-nav');
        const lisLI = mainUL.querySelectorAll(':scope > li');
        if (lisLI.length > 1) {
            return;
        }

        structure.lis.reverse().forEach( element => {
            const newLI = this.createLi(element);
            mainUL.insertAdjacentElement('afterbegin', newLI);
        });

    }
}